import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  Container,
  Typography,
  Box,
  Paper,
  Button,
  Divider,
  Grid,
  Chip
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { trackConversion } from '../components/common/GoogleAdsTag';

const CheckoutSuccess = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  // 从URL参数或location state获取订单信息
  const orderId = new URLSearchParams(location.search).get('orderId') || 
                 (location.state && location.state.orderId) || '未知';
  
  const orderAmount = new URLSearchParams(location.search).get('amount') || 
                    (location.state && location.state.amount) || 0;
  
  const orderItems = location.state && location.state.items 
                   ? location.state.items 
                   : [];
  
  // 跟踪购买转化
  useEffect(() => {
    // 确保这是一个有效的订单
    if (orderId && orderId !== '未知') {
      // 跟踪Google Ads转化
      trackConversion('AW-16953009461', 'NQM-CKSs1YwZEK2uvJMq', {
        'transaction_id': orderId,
        'value': parseFloat(orderAmount),
        'currency': 'SGD'
      });
      
      console.log('成功跟踪订单转化:', orderId, orderAmount);
    }
  }, [orderId, orderAmount]);
  
  return (
    <Container maxWidth="md" sx={{ py: 6 }}>
      <Paper 
        elevation={0} 
        sx={{ 
          p: 4, 
          borderRadius: 2, 
          textAlign: 'center',
          boxShadow: '0 4px 20px rgba(0,0,0,0.08)'
        }}
      >
        <Box 
          sx={{ 
            width: 80, 
            height: 80, 
            bgcolor: 'success.light', 
            borderRadius: '50%', 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center',
            margin: '0 auto 20px'
          }}
        >
          <CheckCircleIcon sx={{ fontSize: 50, color: 'white' }} />
        </Box>
        
        <Typography variant="h4" gutterBottom>
          订单支付成功！
        </Typography>
        
        <Typography variant="body1" color="text.secondary" paragraph>
          感谢您在DestinyCrystal的购物。您的订单已成功支付，正在为您安排发货。
        </Typography>
        
        <Box sx={{ mt: 3, mb: 4 }}>
          <Chip label={`订单编号: ${orderId}`} sx={{ mb: 1, mr: 1 }} />
          <Chip label={`金额: $${orderAmount}`} color="primary" sx={{ mb: 1 }} />
        </Box>
        
        <Divider sx={{ my: 3 }} />
        
        {orderItems.length > 0 && (
          <Box sx={{ my: 3, textAlign: 'left' }}>
            <Typography variant="h6" gutterBottom>
              订单详情
            </Typography>
            
            <Grid container spacing={2} sx={{ mt: 1 }}>
              {orderItems.map((item, index) => (
                <Grid item xs={12} key={index}>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Typography>
                      {item.name} x {item.quantity}
                    </Typography>
                    <Typography>
                      ${parseFloat(item.price * item.quantity).toFixed(2)}
                    </Typography>
                  </Box>
                </Grid>
              ))}
            </Grid>
          </Box>
        )}
        
        <Box sx={{ mt: 4, display: 'flex', justifyContent: 'center', gap: 2 }}>
          <Button 
            variant="outlined" 
            onClick={() => navigate('/user/orders')}
          >
            查看订单
          </Button>
          
          <Button 
            variant="contained" 
            color="primary"
            onClick={() => navigate('/shop')}
          >
            继续购物
          </Button>
        </Box>
      </Paper>
    </Container>
  );
};

export default CheckoutSuccess;